import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {EscolaService} from '../../services/escola.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-cursos-listagem',
  templateUrl: './listagem-cursos.component.html',
  styleUrls: ['../userpanel.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [EscolaService]
})
export class ListagemCursosComponent implements OnInit {

  public arrayTrilhaActiveList = [];
  public arrayTrilhaDoneList = [];
  public loaderActivated = false;
  public baseUrl = environment.apiUrl;

  constructor(private _escolaService: EscolaService) {
    this.loaderActivated = true;
  }

  ngOnInit() {
    this.getTrail();
  }

  getTrail(): void {
    this.arrayTrilhaActiveList = [];
    this.arrayTrilhaDoneList = [];

    this._escolaService.getTrilha()
      .subscribe(result => {
        if (result) {
          const trails = result.data.filter((item) => {
            return item.status === 1;
          });
          for(const trilha of trails) {
            if(trilha.porcentagem == 100) {
              this.arrayTrilhaDoneList.push(trilha);
            }else{
              this.arrayTrilhaActiveList.push(trilha);
            }
          }
          this.loaderActivated = false;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/listagem-cursos/listagem-cursos.component.ts